import React from 'react';
import CodeSnippet02 from 'src/app/icons/Monospaced/CodeSnippet/CodeSnippet02';
import IconCard from 'src/app/molecules/IconCard/IconCard';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import KitLogo from 'src/app/icons/Custom/Logos/Kit';
import ZapierLogo from 'src/app/icons/Custom/Logos/Zapier';
import ZoomLogo from 'src/app/icons/Custom/Logos/Zoom';
import { SpacingPropKeys } from 'styles/spacing';

const IntegrationCards = (): JSX.Element => {
  const integrationCards = [
    {
      title: '2,000+ Embeds',
      description: 'Drop in anything you need. It all just works (and looks great).',
      icon: (
        <CodeSnippet02
          width={40}
          color='var(--base-black)'
        />
      ),
      padding: 'spacing-lg',
    },
    {
      title: 'Kit Integration',
      description: 'Keep your outreach sharp, synched, and right on target.',
      icon: <KitLogo width={56} />,
    },
    {
      title: 'Zapier Integration',
      description: 'Cut out the busywork with a full library to make connections for you.',
      icon: <ZapierLogo width={56} />,
    },
    {
      title: 'Zoom Integration',
      description: 'We’re already on the same page. Generate event links in seconds.',
      icon: <ZoomLogo width={56} />,
    },
  ];

  return (
    <Grid
      maxWidth='width-3xl'
      gap='spacing-7xl'
      gapSm='spacing-4xl'
      totalColumns={4}
      totalColumnsXl={2}
      totalColumnsMd={1}
    >
      {integrationCards.map((card) => (
        <Stack key={card.title}>
          <IconCard
            direction='column'
            gap='spacing-xl'
            heading={{
              text: card.title,
              size: 'lg',
              type: 'paragraph',
              fontWeight: 'font-weight-semibold',
            }}
            supportingText={{
              text: card.description,
              size: 'md',
              type: 'paragraph',
            }}
            featuredIcon={{
              icon: card.icon,
              padding: (card.padding as SpacingPropKeys) ?? 'spacing-xs',
            }}
          />
        </Stack>
      ))}
    </Grid>
  );
};

export default IntegrationCards;
